var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"list"},[_c('tr',{staticClass:"list__header"},_vm._l((_vm.headers),function(head,i){return _c('th',{key:i},[_vm._v(_vm._s(_vm.$t(head)))])}),0),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }